export enum ProgramParticipantType {
  MEETING_ORGANIZATION_ADMIN_PARTICIPANT = "MEETING_ORGANIZATION_ADMIN_PARTICIPANT",
  MEETING_PARTICIPANT = "MEETING_PARTICIPANT",
  TABLETALK_PARTICIPANT = "TABLETALK_PARTICIPANT",
  ASSOCIATED_PROGRAM_PARTICIPANT = "ASSOCIATED_PROGRAM_PARTICIPANT",
  ASSOCIATED_PROGRAM_ACTIVITY_ADMIN_PARTICIPANT = "ASSOCIATED_PROGRAM_ACTIVITY_ADMIN_PARTICIPANT"
}

export const ORG_ADMIN_PARTICIPANT_TYPES = [
  ProgramParticipantType.MEETING_ORGANIZATION_ADMIN_PARTICIPANT,
  ProgramParticipantType.ASSOCIATED_PROGRAM_ACTIVITY_ADMIN_PARTICIPANT
];

export const ATTENDEE_PARTICIPANT_TYPES = [
  ProgramParticipantType.MEETING_PARTICIPANT,
  ProgramParticipantType.TABLETALK_PARTICIPANT,
  ProgramParticipantType.ASSOCIATED_PROGRAM_PARTICIPANT
];
